import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const fmtIt = (d) => (d || "").split("-").reverse().join("/");

export default function ChecklistProgress() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/scadenze/progress").then((r) => setItems(r.data || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="panel" data-testid="checklist-progress" style={{ marginTop: 8 }}>
      <div className="today-head">📈 Avanzamento scadenze in gestione</div>
      <div className="cp-list">
        {items.map((it) => (
          <Link key={it.key} to="/scadenzario-fiscale" className="cp-row" data-testid={`cp-row-${it.key}`}>
            <div className="cp-top">
              <b>{it.label}</b>
              <span className="muted" style={{ fontSize: 12 }}>
                {it.target_date && it.target_date !== it.date && <>🎯 {it.target_label} · </>}
                scad. {fmtIt(it.date)}
              </span>
            </div>
            <div className="cp-bars">
              <div className="cp-bar-wrap">
                <span>✅ Fatte {it.done}/{it.n} ({it.pct_done}%)</span>
                <div className="fc-bar"><div className="fc-bar-fill" style={{ width: `${it.pct_done}%`, background: "#39ff14" }} /></div>
              </div>
              <div className="cp-bar-wrap">
                <span>📤 Inviate {it.sent}/{it.n} ({it.pct_sent}%)</span>
                <div className="fc-bar"><div className="fc-bar-fill" style={{ width: `${it.pct_sent}%`, background: "#38bdf8" }} /></div>
              </div>
              <div className="cp-pace">
                {it.working_days_left > 0
                  ? <>📅 {it.working_days_left} gg lav.{it.target_date && it.target_date !== it.date ? <> al {fmtIt(it.target_date)}</> : null}{it.per_day > 0 && <> · ⚡ ~{it.per_day}/giorno</>}</>
                  : <span style={{ color: "#fb7185" }}>⏰ scade oggi!</span>}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
